import { useEffect } from "react";
import { useLocation } from "react-router";

/**
 * ルート変更時にスクロールを一番上に戻すコンポーネント
 */
export const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
};
